import axios from 'axios';
import { globalStore } from '@/globals';
import { jwtDecode } from 'jwt-decode';

const apiProtocol = window.location.protocol === 'https:' ? 'https' : 'http';
const apiHost     = window.location.protocol === 'https:' ? 'api.imolgaro.com' : '127.0.0.1';
const apiPort     = '44602';

const apiClient = axios.create({
    baseURL: `${apiProtocol}://${apiHost}:${apiPort}`,
    headers: {
        'Content-Type': 'application/json',
    },
});


// HELPER DE TOKEN
const getToken = () => localStorage.getItem('jwtToken');
const removeToken = () => localStorage.removeItem('jwtToken');
const setToken = (token) => localStorage.setItem('jwtToken', token);

// VERIFICAR VALIDADE DO TOKEN
const isTokenValid = () => {
    const token = getToken();
    if (!token) return false;

    try{
        const decodedToken = jwtDecode(token);
        const now = Date.now();
        return decodedToken.exp * 1000 > now;
    } catch(error){
        console.error('Erro ao decodificar o token:', error);
        return false;
    }
};

apiClient.interceptors.request.use((config) => {
    if (config.skipAuth) return config;

    if (!isTokenValid()){
        /// quando vier de loginAPI deve ignorar validação
        removeToken();
        // TODO: REDIRECIONAR PARA TELA DE LOGIN::: EXEMPLO::: window.location.href = '/login';
        return Promise.reject(new Error('Token expirado'));
    }

    const token = getToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));


async function genericDelete(dados) {
    const response = await apiClient.post('/cad/exclusao', dados);
    return response.data;
}


async function genericGet(endpoint, params = {}) {
    const response = await apiClient.get(endpoint, {params: params});
    return response.data;
}


async function genericPost(endpoint, dados) {
    const response = await apiClient.post(endpoint, dados);
    return response.data;
}


async function genericPut(endpoint, dados) {
    const response = await apiClient.put(endpoint, dados);
    return response.data;
}


async function genericAnexo(idAnexo) {
    const response = await apiClient.post('/main/anexo', {id: idAnexo}, {responseType: 'blob'});
    return response.data;
}


async function genericReport(dados) {
    const response = await apiClient.post('/main/relatorio', dados, {responseType: 'blob'});
    return response.data;
}


async function getCadastroById(nmcadastro, id) {
    const response = await apiClient.get(`/cad/${ nmcadastro }`, { params: { id } });
    return response.data;
}


async function loginAPI(userName, passWord, dados = {}) {
    removeToken(); // GARANTIR NÃO TER MAIS TOKEN ATIVO
    globalStore.clear();
    if (!userName) return;
    
    const headers = {
        'Content-Type': 'application/json',
        'jwtusername': userName,
        'jwtpassword': passWord
    };

    try{
        const response = await apiClient.post('/login', dados, { headers, skipAuth: true, });
        if (response.data.token){
            setToken(response.data.token);
            return true;
      }else{return false;}
    } catch (error){
        console.error('Erro durante o login:', error);
        return false;
    }
}

async function loginDisponivel(idCadastro, loginName) {
    try{
        const resp = await apiClient.post('/cad/login_disponivel', { id: idCadastro, nmpesquisar: loginName });
        return (resp.data.bolok === 1) ? true : false;
    }catch{
        return false;
    }
}


function logoutAPI() {
    removeToken();
    globalStore.clear();
    // TODO: REDIRECIONAR PARA TELA DE LOGIN::: EXEMPLO::: window.location.href = '/login';
}




// - Se você controla o front-end, tokens temporários são a melhor opção.
// sobre abrir publicamente esse controller... copilot sugeriu criar esses tokens temporários

async function publicAnexo(idAnexo) {
    const response = await apiClient.post('/public/anexo', {id: idAnexo}, {responseType: 'blob', skipAuth: true});
    return response.data;
}


async function publicPost(endpoint, dados) {
    const response = await apiClient.post(endpoint, dados, {skipAuth: true});
    return response.data;
}

export const Api = {
    genericAnexo,
    genericDelete,
    genericGet,
    genericPost,
    genericPut,
    genericReport,
    getCadastroById,
    loginAPI,
    loginDisponivel,
    logoutAPI,
    publicAnexo,
    publicPost
};